import styled, { css } from 'styled-components';

export const Details = styled.details`
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--card);
  overflow: hidden;

  & + & {
    margin-top: 0.6rem;
  }

  > div {
    padding: 0 1rem 1rem;
    font-size: 0.85rem;
    color: var(--stone-600);
    line-height: 1.5;
  }
`;

export const Summary = styled.summary`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  cursor: pointer;
  list-style: none;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--foreground);

  &::-webkit-details-marker {
    display: none;
  }
`;

/* Envolve o conteúdo passado pelo componente pai e mantém o
   space-between que ele já esperava, agora que a seta ocupa a ponta. */
export const SummaryContent = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`;

export const Chevron = styled.span<{ open: boolean }>`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  color: var(--muted-foreground);
  transition: transform 0.2s ease, color 0.2s ease;

  ${(props: { open: boolean }) =>
    props.open &&
    css`
      transform: rotate(180deg);
      color: var(--primary-hover);
    `}
`;
